export default "__VITE_ASSET__6J0_i6SS__"